// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"78":"b6d556a3","556":"9a3a6bd7","740":"e9d1e19a","901":"2752b4f1","928":"ffc384c2","960":"9364ce8b"}[chunkId] + ".js";
};